// 路由权限 菜单权限
import {get} from "@/assets/Api";
import auth from "@/assets/Js/auth";
import Layout from "@/views/Layout";
import ParentView from "@/components/ParentView";
import dynamicRoutes from "@/router/dynamicRoutes";
import router from "@/router";
import constantRoutes from "@/router/constantRoutes";

const permission = {
    state: {
        routes: [],
        addRoutes: [],
        sidebarRouters: [],
    },
    mutations: {
        SET_SIDEBAR_ROUTERS(state,data) {
            state.sidebarRouters = data;
        },
        SET_ROUTES: (state, routes) => {
            state.addRoutes = routes
            state.routes = constantRoutes.concat(routes)
        },
    },
    actions: {
        GenerateRoutes({ state, rootState, commit, dispatch, getters }) {
            return new Promise((resolve, reject) => {
                get("system/menu/getRouters")
                    .then(res => {
                        if (!res) {
                            reject(false);
                            return;
                        }
                        // console.log("getRouters",res)
                        let data_ = (res.data || []).map((item,index) => {
                            if (index === 0) {
                                item.children = (item.children || []).map((item_,index_) => {
                                    if (index_ === 0) {
                                        item_["alias"] = "/default";
                                    }
                                    return item_;
                                })
                            }
                            return item;
                        });
                        const sdata = JSON.parse(JSON.stringify(data_)),
                              rdata = JSON.parse(JSON.stringify(data_));

                        const sidebarRoutes = filterAsyncRouter(sdata)
                        const rewriteRoutes = filterAsyncRouter(rdata, false, true)
                        const asyncRoutes = filterDynamicRoutes(dynamicRoutes);
                        rewriteRoutes.push({ path: '/:pathMatch(.*)*', redirect: '/404', name: "pathMatchName", hidden: true });
                        (asyncRoutes || []).forEach(item => router.addRoute(item));
                        commit('SET_SIDEBAR_ROUTERS', constantRoutes.concat(sidebarRoutes))
                        commit('SET_ROUTES', rewriteRoutes)
                        resolve(rewriteRoutes);
                    },err => {
                        reject(err);
                    })
            })
        }
    }
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
    return asyncRouterMap.filter(route => {
        if (type && route.children) {
            route.children = filterChildren(route.children)
        }
        if (route.component) {
            // Layout ParentView 组件特殊处理
            if (route.component === 'Layout') {
                route.component = Layout
            } else if (route.component === 'ParentView') {
                route.component = ParentView
            } else if (route.component === 'InnerLink') {
                // route.component = InnerLink
            } else {
                route.component = loadView(route.component)
            }
        }
        if (route.children != null && route.children && route.children.length) {
            route.children = filterAsyncRouter(route.children, route, type)
        } else {
            delete route['children']
            delete route['redirect']
        }
        return true
    })
}

function filterChildren(childrenMap, lastRouter = false) {
    var children = []
    childrenMap.forEach((el, index) => {
        if (el.children && el.children.length) {
            if (el.component === 'ParentView' && !lastRouter) {
                el.children.forEach(c => {
                    c.path = el.path + '/' + c.path
                    if (c.children && c.children.length) {
                        children = children.concat(filterChildren(c.children, c))
                        return
                    }
                    children.push(c)
                })
                return
            }
        }
        if (lastRouter) {
            el.path = lastRouter.path + '/' + el.path
        }
        children = children.concat(el)
    })
    return children
}

// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes(routes) {
    const res = [];
    routes.forEach(route => {
        if (route.permissions) {
            if (auth.hasPermiOr(route.permissions)) {
                res.push(route)
            }
        } else if (route.roles) {
            if (auth.hasRoleOr(route.roles)) {
                res.push(route)
            }
        }
    })
    return res
}

export const loadView = (view) => {
    if (process.env.NODE_ENV === 'development') {
        // return (resolve) => require([`@/views/modules/${view}`], resolve) vue2
        return () => import(`@/views/modules/${view}`) // vue3
    } else {
        // 使用 import 实现生产环境的路由懒加载
        return () => import(`@/views/modules/${view}`)
    }
}

export default permission;
